import { DialogActions } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
/**
 * This component is always located at the bottom of a slideout, used, for example, to render some action buttons
 */
export const ModalSlideoutActions = (props) => {
    return (React.createElement(DialogActions, { sx: {
            borderTop: `1px solid ${themeColors.border.main}`,
            position: 'sticky',
            bottom: 0,
            p: 0,
            background: themeColors.surface.primary,
        }, "data-test": props['data-test'] }, props.children));
};
